import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpenseOverviewComponent } from './expense-overview.component';
import { ExpenseAccordionModule } from '../expense-accordion/expense-accordion.module';

@NgModule({
  imports: [CommonModule, ExpenseAccordionModule],
  exports: [ExpenseOverviewComponent],
  declarations: [ExpenseOverviewComponent],
})
export class ExpenseOverviewModule {}
